// frontend/src/pages/auth/login/loginTranslations.ts
/**
 * 🧠 Pensado por Alcélio Gomes - Codificado com Claude Code
 * 🚀 NeuroAgentes Platform - Intelligent Agent Development
 *
 * Textos da tela de login, por idioma.
 *
 * EXTRAÍDO de LoginPage.tsx em 30/08/2026: a página passava de 500 linhas e
 * mais da metade era conteúdo, não comportamento. Separado para que mexer em
 * texto não signifique abrir o componente.
 */

export interface Languages {
  [key: string]: {
    loginTitle: string;
    username: string;
    password: string;
    signIn: string;
    forgotPassword: string;
    clickHere: string;
    noAccount: string;
    signUp: string;
    emailError: string;
    emailRequired: string;
    passwordMin: string;
    passwordRequired: string;
    errorDefault: string;
  };
}

export const translations: Languages = {
  pt: {
    loginTitle: "ENTRAR",
    username: "E-mail",
    password: "Senha",
    signIn: "ENTRAR",
    forgotPassword: "Esqueceu a senha?",
    clickHere: "Clique aqui",
    noAccount: "Não tem uma conta?",
    signUp: "Cadastre-se",
    emailError: "Digite um e-mail válido",
    emailRequired: "E-mail é obrigatório",
    passwordMin: "A senha deve ter pelo menos 8 caracteres",
    passwordRequired: "Senha é obrigatória",
    errorDefault: "Ocorreu um erro ao tentar fazer login. Tente novamente."
  },
  en: {
    loginTitle: "LOGIN",
    username: "Username",
    password: "Password",
    signIn: "SIGN IN",
    forgotPassword: "Forgot Password?",
    clickHere: "Click Here",
    noAccount: "Don't have an account?",
    signUp: "Sign Up",
    emailError: "Enter a valid email",
    emailRequired: "Email is required",
    passwordMin: "Password should be at least 8 characters",
    passwordRequired: "Password is required",
    errorDefault: "An error occurred while trying to log in. Please try again."
  }
};

// Componente para seleção de idioma
